var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3333 5.66667H12C12.7333 5.66667 13.3333 6.26667 13.3333 7V13.6667C13.3333 14.4 12.7333 15 12 15H3.99999C3.26666 15 2.66666 14.4 2.66666 13.6667V7C2.66666 6.26667 3.26666 5.66667 3.99999 5.66667H4.66666V4.33333C4.66666 2.49333 6.15999 1 7.99999 1C9.83999 1 11.3333 2.49333 11.3333 4.33333V5.66667ZM7.99999 2.33333C6.89332 2.33333 5.99999 3.22667 5.99999 4.33333V5.66667H9.99999V4.33333C9.99999 3.22667 9.10666 2.33333 7.99999 2.33333ZM3.99999 13.6667V7H12V13.6667H3.99999ZM9.33332 10.3333C9.33332 11.0667 8.73332 11.6667 7.99999 11.6667C7.26666 11.6667 6.66666 11.0667 6.66666 10.3333C6.66666 9.6 7.26666 9 7.99999 9C8.73332 9 9.33332 9.6 9.33332 10.3333Z",
    fill: "#F07C11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowlock);
export default __webpack_public_path__ + "static/media/yellowlock.7b9e8a7f.svg";
export { ForwardRef as ReactComponent };